import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface Service {
    title: string;
    description: string;
    icon: React.ReactNode;
    features: string[];
}

const services: Service[] = [
    {
        title: 'Développement Web & Mobile',
        description: 'Applications modernes et performantes adaptées à vos besoins',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
        ),
        features: ['Sites Web Responsifs', 'Applications Mobiles', 'PWA', 'API RESTful'],
    },
    {
        title: 'Solutions Cloud & Hébergement',
        description: 'Infrastructure cloud scalable et solutions d\'hébergement sécurisées',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
            </svg>
        ),
        features: ['Hébergement', 'Scalabilité', 'Backup', 'Monitoring'],
    },
    {
        title: 'Cybersécurité',
        description: 'Protection avancée contre les menaces et audits de sécurité',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
        ),
        features: ['Audit de Sécurité', 'Protection DDoS', 'Chiffrement', 'Formation'],
    },
    {
        title: 'Consulting & Formation',
        description: 'Expertise technique et programmes de formation personnalisés',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
        ),
        features: ['Formation Technique', 'Conseil Stratégique', 'Audit IT', 'Accompagnement'],
    },
    {
        title: 'IA & Automatisation',
        description: 'Solutions d\'intelligence artificielle et automatisation des processus',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
        ),
        features: ['Machine Learning', 'Chatbots', 'RPA', 'Analyse de Données'],
    },
    {
        title: 'Networks',
        description: 'Infrastructure réseau robuste et solutions de connectivité',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
            </svg>
        ),
        features: ['Infrastructure Réseau', 'VPN', 'Sécurité Réseau', 'Maintenance'],
    },
    {
        title: 'Graphic Design',
        description: 'Design créatif et identité visuelle professionnelle',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
        ),
        features: ['Identité Visuelle', 'UI/UX Design', 'Branding', 'Marketing Visuel'],
    },
    {
        title: 'E-commerce Solutions',
        description: 'Solutions complètes pour votre commerce en ligne',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
        ),
        features: ['Boutiques en Ligne', 'Paiement Sécurisé', 'Gestion des Stocks', 'Marketing Digital'],
    },
    {
        title: 'Business Intelligence',
        description: 'Analyses avancées et insights stratégiques pour votre entreprise',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
        ),
        features: ['Tableaux de Bord', 'Analyse Prédictive', 'Reporting Automatisé', 'KPIs'],
    },
    {
        title: 'IoT & Systèmes Embarqués',
        description: 'Solutions connectées et systèmes intelligents',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
            </svg>
        ),
        features: ['Capteurs Intelligents', 'Automatisation', 'Monitoring Temps Réel', 'Edge Computing'],
    },
    {
        title: 'Support & Maintenance',
        description: 'Support technique continu et maintenance préventive',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
        ),
        features: ['Support 24/7', 'Maintenance Préventive', 'Mises à Jour', 'Résolution Rapide'],
    },
    {
        title: 'Vidéosurveillance',
        description: 'Solutions de sécurité et systèmes de surveillance professionnels',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
        ),
        features: ['Caméras IP', 'Systèmes DVR/NVR', 'Vision Nocturne', 'Accès à Distance'],
    },
    {
        title: 'Dépannage Informatique',
        description: 'Réparation et maintenance de matériel et logiciel',
        icon: (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
            </svg>
        ),
        features: ['Réparation PC/Mac', 'Récupération de Données', 'Dépannage Logiciel', 'Optimisation Système'],
    },
];

const ServiceCard: React.FC<{ service: Service; index: number }> = ({ service, index }) => {
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    const [isHovered, setIsHovered] = useState(false);

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            whileHover={{
                y: -10,
                scale: 1.02,
                transition: { duration: 0.2 }
            }}
            onHoverStart={() => setIsHovered(true)}
            onHoverEnd={() => setIsHovered(false)}
            className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden transform-gpu"
        >
            <div className="p-6 relative">
                <motion.div
                    animate={{
                        rotateY: isHovered ? 180 : 0,
                        scale: isHovered ? 1.1 : 1
                    }}
                    transition={{ duration: 0.3 }}
                    className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center text-blue-600 dark:text-blue-400 mb-4"
                >
                    <motion.div
                        animate={{ scale: isHovered ? 1.2 : 1 }}
                        transition={{ duration: 0.2 }}
                    >
                        {service.icon}
                    </motion.div>
                </motion.div>

                <motion.h3
                    animate={{
                        color: isHovered ? '#3B82F6' : '',
                        x: isHovered ? 10 : 0
                    }}
                    transition={{ duration: 0.2 }}
                    className="text-xl font-semibold text-gray-900 dark:text-white mb-2"
                >
                    {service.title}
                </motion.h3>

                <motion.p
                    animate={{ opacity: isHovered ? 0.9 : 0.7 }}
                    transition={{ duration: 0.2 }}
                    className="text-gray-600 dark:text-gray-300 mb-4"
                >
                    {service.description}
                </motion.p>

                <ul className="space-y-2">
                    {service.features.map((feature, i) => (
                        <motion.li
                            key={i}
                            initial={{ x: -20, opacity: 0 }}
                            animate={{
                                x: inView ? 0 : -20,
                                opacity: inView ? 1 : 0,
                            }}
                            transition={{ delay: index * 0.1 + i * 0.1 }}
                            whileHover={{ x: 5 }}
                            className="flex items-center text-gray-600 dark:text-gray-300"
                        >
                            <motion.div
                                animate={{
                                    rotate: isHovered ? [0, 360] : 0,
                                    scale: isHovered ? [1, 1.2, 1] : 1
                                }}
                                transition={{ duration: 0.3, delay: i * 0.1 }}
                            >
                                <svg
                                    className="w-4 h-4 mr-2 text-green-500"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                            </motion.div>
                            {feature}
                        </motion.li>
                    ))}
                </ul>

                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{
                        opacity: isHovered ? 1 : 0,
                        scale: isHovered ? 1 : 0.8,
                        x: isHovered ? 0 : 20
                    }}
                    transition={{ duration: 0.2 }}
                    className="absolute top-4 right-4 text-blue-500"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                    </svg>
                </motion.div>
            </div>
        </motion.div>
    );
};

const ServiceSection = () => {
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    return (
        <section className="py-20 bg-gray-50 dark:bg-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    ref={ref}
                    initial={{ opacity: 0, y: 20 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                        Nos Services
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                        Découvrez notre gamme complète de services technologiques conçus pour propulser votre entreprise
                        vers le succès
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {services.map((service, index) => (
                        <ServiceCard key={index} service={service} index={index} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;